<template>
  <v-row>
    <v-col
      cols="12"
      lg="3"
    >
      <kpi-card-component
        :title="$tc('categories.project.name', 2)"
        :quantity="dashboard.projects_kpi"
        :img="assets.homeProjects"
        :to="toProjects"
      />
    </v-col>
    <v-col
      cols="12"
      lg="3"
    >
      <kpi-card-component
        :title="$t('categories.inspection.in_progress')"
        :quantity="dashboard.inspections_kpi"
        :img="assets.homeInspectionsOngoing"
        :to="toAllInspections"
      />
    </v-col>
    <v-col
      cols="12"
      lg="3"
    >
      <kpi-card-component
        :title="$tc('categories.nonconformity.name', 2)"
        :quantity="dashboard.non_conformities_kpi"
        :img="assets.homeNonconformities"
        :to="toAllNonConformities"
      />
    </v-col>
    <v-col
      cols="12"
      lg="3"
    >
      <kpi-card-component
        :title="$tc('categories.nonconformity.action.name', 2)"
        :quantity="dashboard.actions_kpi"
        :img="assets.homeActions"
        :to="toAllActions"
      />
    </v-col>
  </v-row>
</template>

<script>
import KpiCardComponent from "@/components/ri3/KpiCardComponent.vue"
import { getAssets } from "@/plugins/vuetify"

export default {
  name: "HomeKPI",
  components: {
    KpiCardComponent
  },
  props: {
    dashboard: {
      type: Object
    }
  },
  computed: {
    assets() {
      return getAssets(this)
    }
  },
  data() {
    return {
      toAllActions: { name: "AllActions" },
      toAllInspections: { name: "AllInspections" },
      toAllNonConformities: { name: "AllNonConformities" },
      toProjects: { name: "Projects" }
    }
  }
}
</script>
